import { ICONS } from '@client/constants/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/claims')({
    staticData: {
        breadcrumb: {
            title: 'Claims',
        },
        ui: {
            icon: ICONS.claim,
        },
        // CUR-2675: the Accounts role reads every claim, read only.
        roles: ['user', 'shared_edit_user', 'org_admin', 'accounts'],
        modules: ['claim'],
    },
    component: Outlet,
});
